export default "__VITE_ASSET__ZdV8wwnk__"